import { useConexaQuery } from '@/hooks/useConexaQuery'
import { RealtimeAttendanceMonitoringService } from '../services'
import { useRealtimeAppointmentStore } from '../store/use-realtime-appointment-store'

const TWENTY_SECONDS_IN_MS = 20000

export const useGetRealtimeAppointments = (
  patientId: string | number,
  interval = TWENTY_SECONDS_IN_MS,
) => {
  return useConexaQuery({
    queryKey: ['realtiment-appointment', patientId],
    service: async () => {
      const appointments =
        await RealtimeAttendanceMonitoringService.getAppointmentStatus(
          patientId,
        )

      useRealtimeAppointmentStore.setState({
        appointments,
      })
      return appointments
    },
    config: {
      initialData: [],
      enabled: Boolean(patientId),
      refetchOnWindowFocus: true,
      refetchIntervalInBackground: true,
      refetchInterval: interval,
    },
  })
}
